import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import SelectLn2Message from "../select/SelectLn2Message";
// TYPES
import { Ln2MessageFilter } from "../../../flatbuffers/types/ln2MessageOptions";

export default function FormSelectMessage({
  inputValue,
  inputOnChange,
  disabledInput,
  displaySelect,
  messageFilter = undefined,
}: {
  inputValue: string;
  inputOnChange: (newValue: string, variableName: string) => void;
  disabledInput: boolean;
  displaySelect: boolean;
  messageFilter?: Ln2MessageFilter;
}) {
  const [t] = useTranslation("global");

  return (
    <div className="col-md-12 mt-3">
      <div className="generalStyles__flex">
        <div className="generalStyles__inputFlexNameLarge">
          <span className="generalStyles__inputFlexRequired">*</span>
          <span>{t("general.message")}</span>
        </div>
        <div className="generalStyles__width100">
          <SelectLn2Message
            value={inputValue}
            onChange={(key: string) => inputOnChange(key, "msg_id")}
            disabled={disabledInput}
            displayOnly={!displaySelect}
            messageFilter={messageFilter}
          />
        </div>
        <div className="generalStyles__infoTooltipIconBlank" />
      </div>
    </div>
  );
}
